/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { Grid, Box, Typography } from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '../../Utils/RichEditor';

const STEP6_FIELDS = [
   'general_terms_and_conditions',
   'project_termination_terms',
   'payment_terms',
   'application_ownership',
   'liability',
   'legal_jurisdiction',
];

// NEW: all Step 6 fields share the same 5000-character limit
const STEP6_MAX_LENGTH = 5000;

function StepSix({ isSubmitting, values, setFieldValue, touched, errors, initialValues }) {
   const fields = [
      { name: 'general_terms_and_conditions', label: 'General Terms & Conditions' },
      { name: 'project_termination_terms', label: 'Project Termination Terms' },
      { name: 'payment_terms', label: 'Payment Terms & Conditions' },
      { name: 'application_ownership', label: 'Application Ownership' },
      { name: 'liability', label: 'Liability' },
      { name: 'legal_jurisdiction', label: 'Legal Jurisdiction' },
   ];

   // NEW: live character-length errors for each field
   const [fieldLengthErrors, setFieldLengthErrors] = useState({});

   // NEW: checks length against STEP6_MAX_LENGTH and stores/clears the error message

   const getCharCount = (value) => {
      if (!value) return 0;
      return String(value).replace(/\s/g, '').length;   // strip whitespace only, keep HTML tags in the count
   };
   const checkLengthError = (fieldName, value) => {
      const length = getCharCount(value);
      setFieldLengthErrors((prev) => ({
         ...prev,
         [fieldName]:
            length > STEP6_MAX_LENGTH
               ? `This field is too long. Please keep it within ${STEP6_MAX_LENGTH} characters.`
               : '',
      }));
   };

   return (
      <>
         <div className="card stepCard">
            <Box className="card-body" sx={{ padding: '15px' }}>
               <Grid container spacing={2}>
                  <Grid item md={12} xs={12}>
                     <Box className="commonBox">
                        <Grid container spacing={2}>
                           {fields.map(({ name, label }) => (
                              <Grid item md={12} xs={12} key={name}>
                                 <Typography variant="h6" gutterBottom align="left">
                                    {label}
                                 </Typography>
                                 <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                       <Field name={name}>
                                          {() => (<>
                                             <CKEditor
                                                editor={ClassicEditor}
                                                data={values[name] || ''}
                                                onReady={(editor) => {
                                                   // When editor mounts, if value exists
                                                   // push it in directly — this handles
                                                   // the case where data prop is ignored
                                                   if (values[name]) {
                                                      editor.setData(values[name]);
                                                   }
                                                }}
                                                onChange={(event, editor) => {
                                                   const val = editor.getData();
                                                   setFieldValue(name, val);
                                                   checkLengthError(name, val); {/* NEW */ }
                                                }}
                                             />
                                             {values[name] && (
                                                <Typography
                                                   variant="caption"
                                                   color="GrayText"
                                                   sx={{ mt: 0.5, display: 'block' }}
                                                >
                                                   {getCharCount(values[name])} characters
                                                </Typography>
                                             )}
                                             {/* NEW: red length-limit error, shown like a helper text below the field */}
                                             {/* {fieldLengthErrors[name] && (
                                                <Typography
                                                   variant="caption"
                                                   sx={{ mt: 0.5, display: 'block', color: '#d32f2f' }}
                                                >
                                                   {fieldLengthErrors[name]}
                                                </Typography>
                                             )} */}
                                             {touched[name] && errors[name] ? (
                                                <Typography
                                                   variant="caption"
                                                   sx={{ mt: 0.5, display: 'block', color: '#d32f2f' }}
                                                >
                                                   {errors[name]}
                                                </Typography>
                                             ) : fieldLengthErrors[name] && (
                                                <Typography
                                                   variant="caption"
                                                   sx={{ mt: 0.5, display: 'block', color: '#d32f2f' }}
                                                >
                                                   {fieldLengthErrors[name]}
                                                </Typography>
                                             )}
                                          </>
                                          )}
                                       </Field>
                                       {/* <ErrorMessage
                                          name={name}
                                          component="div"
                                          style={{ color: 'red' }}
                                       /> */}
                                    </Grid>
                                 </Grid>
                              </Grid>
                           ))}
                        </Grid>
                     </Box>
                  </Grid>
               </Grid>
            </Box>
         </div>
      </>
   );
}

export default StepSix;